/**
 * Generates HEX color between two different color based on the percentage provided.
 * @param ratio
 * @param endColor
 * @param startColor
 */
export function perc2color(ratio, endColor, startColor) {
  startColor = startColor.replace('#', '');
  endColor = endColor.replace('#', '');

  const hex = function (x) {
    x = x.toString(16);
    return x.length === 1 ? `0${x}` : x;
  };

  const r = Math.ceil(
    parseInt(endColor.slice(0, 2), 16) * ratio + parseInt(startColor.slice(0, 2), 16) * (1 - ratio)
  );
  const g = Math.ceil(
    parseInt(endColor.slice(2, 4), 16) * ratio + parseInt(startColor.slice(2, 4), 16) * (1 - ratio)
  );
  const b = Math.ceil(
    parseInt(endColor.slice(4, 6), 16) * ratio + parseInt(startColor.slice(4, 6), 16) * (1 - ratio)
  );

  return `#${hex(r) + hex(g) + hex(b)}`;
}

export default {
  perc2color,
};
